module.exports = __webpack_public_path__ + "static/media/corded-ware_germany_preview.0912aacc.png";